"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProgressBar = void 0;
var _react = _interopRequireDefault(require("react"));
var _Tooltip = _interopRequireDefault(require("../../common/Tooltip/Tooltip"));
require("./ProgressBar.css");
var _cssClassesHelper = require("../../../helpers/cssClassesHelper");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bem = (0, _cssClassesHelper.getBEMClasses)('custom-progress-bar');
var ProgressBar = exports.ProgressBar = function ProgressBar(_ref) {
  var percentage = _ref.percentage,
    tooltip = _ref.tooltip;
  var percentValue = percentage;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "custom-progress-bar-wrapper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bem()
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bem('fill'),
    style: {
      width: "".concat(percentValue, "%")
    }
  })), tooltip ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
    text: tooltip
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: bem('label', 'with-tooltip')
  }, percentValue, "%")) : /*#__PURE__*/_react["default"].createElement("span", {
    className: bem('label')
  }, percentValue, "%"));
};